<div class="{{ AUI?.pos }} alert alert-{{ AUI?.type }} ui" *ngIf="AUI?.active">
  <p [innerHTML]="AUI?.message"></p>
</div>
